import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import Layout, {Caricamento, Titolo, Vuoto} from '../Layout';
import {Avvisi, Errore, STATI_ORDINE_FILTRO, TabellaOrdini, gestisciErrore, getOrdini, giorniFa, oggi} from '../woo';

// Elenco ordini del sito con filtri per periodo e stato. I filtri stanno nella query string,
// cosi' tornando indietro da un ordine si ritrova lo stesso elenco.
export default function OrdiniPage() {
    const [params, setParams] = useSearchParams();
    const filtri = {
        dal: params.get('dal') ?? giorniFa(30),
        al: params.get('al') ?? oggi(),
        stato: params.get('stato') ?? '',
    };
    const [form, setForm] = useState(filtri);
    const [risultato, setRisultato] = useState(null); // null = in caricamento
    const [errore, setErrore] = useState('');

    useEffect(() => {
        setRisultato(null);
        setErrore('');
        getOrdini({from: filtri.dal, to: filtri.al, status: filtri.stato})
            .then(setRisultato)
            .catch(gestisciErrore(setErrore));
    }, [filtri.dal, filtri.al, filtri.stato]);

    function cerca(event) {
        event.preventDefault();
        setParams(form);
    }

    const ordini = risultato?.ordini ?? [];

    return (
        <Layout>
            <Titolo>Ordini e-commerce</Titolo>
            <div className="card mb-3">
                <div className="card-body">
                    <form className="row g-3 align-items-end" onSubmit={cerca}>
                        <div className="col-auto">
                            <label className="form-label" htmlFor="dal">Dal</label>
                            <input id="dal" type="date" className="form-control" value={form.dal} required
                                   onChange={(e) => setForm({...form, dal: e.target.value})}/>
                        </div>
                        <div className="col-auto">
                            <label className="form-label" htmlFor="al">Al</label>
                            <input id="al" type="date" className="form-control" value={form.al} required
                                   onChange={(e) => setForm({...form, al: e.target.value})}/>
                        </div>
                        <div className="col-auto">
                            <label className="form-label" htmlFor="stato">Stato</label>
                            <select id="stato" className="form-select" value={form.stato}
                                    onChange={(e) => setForm({...form, stato: e.target.value})}>
                                <option value="">Tutti</option>
                                {STATI_ORDINE_FILTRO.map((s) => <option key={s.valore} value={s.valore}>{s.etichetta}</option>)}
                            </select>
                        </div>
                        <div className="col-auto">
                            <button type="submit" className="btn btn-primary">
                                <i className="bi-search me-2"></i>Cerca
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <Errore messaggio={errore}/>
            <Avvisi avvisi={risultato?.avvisi}/>
            <div className="card">
                <div className="card-body">
                    {!errore && risultato === null && <Caricamento/>}
                    {risultato && ordini.length === 0 && <Vuoto>Nessun ordine nel periodo.</Vuoto>}
                    {ordini.length > 0 && (
                        <>
                            <p className="text-secondary small mb-2">{risultato.totale} ordini</p>
                            <TabellaOrdini ordini={ordini}/>
                        </>
                    )}
                </div>
            </div>
        </Layout>
    );
}
